module.exports = __webpack_public_path__ + "img/male-youngchild-figure.dcb875d9.svg";